import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface UploadTaskSnapshot {
  state: string;
  bytesTransferred: number;
  totalBytes: number;
}

export interface UploadTaskHandle {
  percentageChanges: () => Observable<number>;
  snapshotChanges: () => Observable<UploadTaskSnapshot>;
  getDownloadURL: () => Promise<string>;
  pause: () => boolean;
  resume: () => boolean;
  cancel: () => boolean;
}

export interface UploadEntity extends UploadTaskHandle {
  id?: string | number;
}

export interface UploadFacade {
  loaded$: Observable<boolean>;
  allUpload$: Observable<UploadEntity[]>;
  selectedUpload$: Observable<UploadEntity>;
  upload(files: File[], folderName: string): void;
  cleanUploads(): void;
}

export const UPLOAD_FACADE = new InjectionToken<UploadFacade>('UPLOAD_FACADE');
